export interface StoryPart {
  text: string;
  imagePrompt: string;
  imageUrl?: string;
}

export interface Story {
  id: string;
  userId: string;
  title: string;
  parts: StoryPart[];
  audioBase64?: string;
  createdAt: number;
}

export interface User {
  id: string;
  email: string;
  name: string;
  password?: string; // Në prodhim kjo do të ishte një token/hash
  tokens: number;
  isLoggedIn: boolean;
  isVerified: boolean;
  joinedAt: number;
  avatarId?: number;
  hasReceivedPromo?: boolean;
  justReceivedPromo?: boolean;
}

export interface UserInput {
  characterName: string;
  referencePrompt: string;
  photoBase64: string | null;
  voiceType: 'female' | 'male';
  storyType: 'fairytale' | 'adventure' | 'funny' | 'sci-fi' | 'bedtime' | 'albanian_folklore';
  ageCategory: '0-3' | '3-6' | '6-9' | '9+';
}

export interface GeneratedStoryResponse {
  title: string;
  parts: {
    text: string;
    imagePrompt: string;
  }[];
}

export enum AppState {
  IDLE = 'IDLE',
  GENERATING_STORY = 'GENERATING_STORY',
  GENERATING_IMAGES = 'GENERATING_IMAGES',
  GENERATING_AUDIO = 'GENERATING_AUDIO',
  REVIEWING_STORY = 'REVIEWING_STORY',
  READING_STORY = 'READING_STORY',
  LIBRARY = 'LIBRARY',
  AUTH = 'AUTH',
  VERIFYING = 'VERIFYING',
  PROFILE = 'PROFILE',
  SHOP = 'SHOP',
  SHARED_STORY = 'SHARED_STORY',
  EMAIL_ACTION = 'EMAIL_ACTION'
}

declare global {
  interface Window {
    aistudio: {
      hasSelectedApiKey: () => Promise<boolean>;
      openSelectKey: () => Promise<void>;
    };
  }
}
